'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

/**
 * Client component that syncs the body class with the current route
 * to handle confidential mode styling during client-side navigation.
 *
 * This is needed because the server-side layout only sets the class
 * on initial render, but doesn't update on client-side navigation.
 */
export function ConfidentialModeBodyClass() {
  const pathname = usePathname();

  useEffect(() => {
    const isConfidentialMode = pathname?.startsWith('/confidential/') ?? false;
    const body = document.body;

    if (isConfidentialMode) {
      body.classList.add('confidential-mode');
    } else {
      body.classList.remove('confidential-mode');
    }

    // Cleanup function to remove class if component unmounts
    return () => {
      body.classList.remove('confidential-mode');
    };
  }, [pathname]);

  return null;
}
